import { useState, type FormEvent } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { InlineAlert } from '@/components/feedback';
import { Button, PasswordField, TextField } from '@/components/forms';
import { AuthLayout } from '@/components/layout';
import { AUTH_UNAVAILABLE, useSession } from './session/context';

/** Criar conta (primeiro passo do onboarding), no mesmo card do login (`auth.html`). */
export function SignUpPage() {
  const navigate = useNavigate();
  const session = useSession();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  if (session.status === 'ready' && session.viewer) return <Navigate to="/onboarding" replace />;
  const invite = session.status === 'ready' && session.signupMode === 'INVITE';

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (session.status === 'demo') {
      setError(AUTH_UNAVAILABLE);
      return;
    }
    if (!name.trim()) return setError('Informe seu nome.');
    if (!email.trim()) return setError('Informe seu e-mail.');
    if (password.length < 8) return setError('A senha precisa ter pelo menos 8 caracteres.');
    setBusy(true);
    setError(null);
    const r = await session.signUp(name, email, password);
    setBusy(false);
    if (r.error) setError(r.error);
    else navigate('/onboarding', { replace: true });
  };

  return (
    <AuthLayout badge="Ambiente de teste">
    <form className="auth-card" id="signup" noValidate onSubmit={onSubmit}>
      <h2>Crie sua conta</h2>
      <p className="lead">{invite ? 'O cadastro está disponível só por convite no momento.' : 'Comece a usar a Lisboon em poucos minutos.'}</p>
      <TextField id="name" label="Nome" icon="user" placeholder="Seu nome" autoComplete="name" value={name} onChange={(e) => setName(e.target.value)} />
      <TextField id="email" label="E-mail" icon="mail" type="email" placeholder="seu@email.com" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} />
      <PasswordField id="pw" label="Senha" placeholder="Mínimo de 8 caracteres" autoComplete="new-password" value={password} onChange={(e) => setPassword(e.target.value)} />
      {error && <InlineAlert tone="err">{error}</InlineAlert>}
      <Button block type="submit" disabled={busy || session.status === 'loading'}>{busy ? 'Criando conta…' : 'Criar conta'}</Button>
      <div className="or">ou</div>
      <Button variant="outline-gold" block to="/auth">Já tenho conta</Button>
    </form>
    </AuthLayout>
  );
}
